var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.314 29.012C46.9386 29.0088 46.5992 29.0064 46.3032 29.0047C46.2509 29.0016 46.1981 29 46.1449 29H43.8587C43.8027 29 43.7472 29.0018 43.6922 29.0052C43.3976 29.0071 43.0602 29.0097 42.6874 29.0131C41.2817 29.0262 39.3675 29.0525 37.3381 29.105C35.3123 29.1575 33.1534 29.2366 31.2638 29.3567C29.4379 29.4728 27.67 29.6372 26.5402 29.9005L26.5086 29.9081C25.1443 30.2445 23.9051 30.8888 22.9165 31.777C21.9279 32.6652 21.2249 33.7658 20.8796 34.968C20.8672 35.0114 20.8564 35.0551 20.8473 35.0991C20.1688 38.3776 19.8366 41.7035 19.8547 45.0349C19.8313 48.3914 20.1636 51.7426 20.8473 55.0459C20.8608 55.111 20.878 55.1756 20.8988 55.2393C21.2794 56.404 21.998 57.4627 22.9843 58.3133C23.9706 59.1639 25.191 59.7778 26.5275 60.0965L26.5402 60.0995C27.67 60.3628 29.4379 60.5272 31.2638 60.6433C33.1534 60.7634 35.3123 60.8425 37.3381 60.895C39.3675 60.9475 41.2817 60.9738 42.6874 60.9869C43.0603 60.9903 43.3976 60.9929 43.6922 60.9948C43.7472 60.9982 43.8027 61 43.8587 61H46.1449C46.2008 61 46.2564 60.9982 46.3113 60.9948C46.6059 60.9929 46.9433 60.9903 47.3161 60.9869C48.7218 60.9738 50.636 60.9475 52.6655 60.895C54.6913 60.8425 56.8502 60.7634 58.7398 60.6433C60.5657 60.5272 62.3335 60.3628 63.4634 60.0995L63.495 60.0919C64.8592 59.7555 66.0984 59.1112 67.087 58.223C68.0757 57.3348 68.7786 56.2342 69.1239 55.032C69.1364 54.9886 69.1472 54.9449 69.1563 54.9008C69.8296 51.6466 70.1618 48.3457 70.1489 45.0389C70.1724 41.6819 69.8401 38.3303 69.1563 35.0266C69.1472 34.9826 69.1364 34.9389 69.1239 34.8956C68.7786 33.6934 68.0757 32.5928 67.087 31.7046C66.0984 30.8164 64.8592 30.172 63.495 29.8357C63.4685 29.8291 63.4419 29.823 63.4152 29.8173C62.3034 29.5808 60.5521 29.4313 58.7254 29.3253C56.8398 29.2159 54.6841 29.1437 52.6596 29.0958C50.6318 29.0479 48.7189 29.0239 47.314 29.012ZM40.0858 38.2322C39.8578 38.4986 39.8578 38.9759 39.8578 39.9305V50.0691C39.8578 51.0237 39.8578 51.501 40.0858 51.7675C40.2846 51.9997 40.5887 52.1449 40.9195 52.1656C41.299 52.1893 41.7579 51.9312 42.6758 51.415L51.6899 46.3457C52.4863 45.8978 52.8846 45.6738 53.0222 45.389C53.1423 45.1402 53.1423 44.8594 53.0222 44.6106C52.8846 44.3258 52.4864 44.1019 51.6899 43.6539L42.6758 38.5846C41.7579 38.0684 41.299 37.8103 40.9195 37.834C40.5887 37.8547 40.2846 38 40.0858 38.2322Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 9
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.088b54d5502631ca085b6889de47038a.svg";
export { ForwardRef as ReactComponent };